import axios from 'axios';
import { axiosRequest, DHLError, handleHttpResponse } from '@general/js/utils';

import AbstractClass from './SupportAbstractServices';
import Services from '../Services';

export default class SupportServices extends AbstractClass {
  /**
   * Get reference data of form on public site contact us page
   * @returns {object}
   */
  static async getContactUsReferenceData() {
    try {
      const response = await axios.get(Services.SUPPORT.CONTACT_US.GET_REFERENCE_DATA);
      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getContactUsReferenceData() - call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  /**
   * Post contact us form for both public website and contact us page
   * @param {object} payload - form response
   * @returns
   */
  static async postContactUsFeedback(payload) {
    try {
      const response = await axiosRequest().post(Services.SUPPORT.CONTACT_US.POST_FEEDBACK, payload);
      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`postContactUsFeedback() - call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  /**
   * Get related articles reference data for public website contact us confirmation page
   * @returns {object}
   */
  static async getContactUsConfirmationRelatedArticles() {
    try {
      const response = await axios.get(Services.SUPPORT.CONTACT_US.GET_CONFIRMATION_REFERENCE_DATA);
      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getContactUsConfirmationReferenceData() - call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }
}
